import * as enUs from 'store/initialState/langs/en-US.js'


export default {
    ...enUs.default

}